/**
 * @escapehub/token-creator-core - Contract ABIs
 *
 * Exports ABIs for LaunchERC20 and LaunchERC20Factory contracts.
 * These are the raw ABIs extracted from the compiled Solidity contracts.
 */

import LaunchERC20ABI from './LaunchERC20.abi.json';
import LaunchERC20FactoryABI from './LaunchERC20Factory.abi.json';

export { LaunchERC20ABI, LaunchERC20FactoryABI };

/**
 * Human-readable ABI for common LaunchERC20 read functions.
 * Use this for lighter bundle size when you only need specific functions.
 */
export const LaunchERC20ReadABI = [
  'function name() view returns (string)',
  'function symbol() view returns (string)',
  'function decimals() view returns (uint8)',
  'function totalSupply() view returns (uint256)',
  'function balanceOf(address) view returns (uint256)',
  'function owner() view returns (address)',
  'function tradingEnabled() view returns (bool)',
  'function feesModuleEnabled() view returns (bool)',
  'function limitsModuleEnabled() view returns (bool)',
  'function blacklistModuleEnabled() view returns (bool)',
  'function whitelistModuleEnabled() view returns (bool)',
  'function antiDumpModuleEnabled() view returns (bool)',
  'function buyFeeBps() view returns (uint16)',
  'function sellFeeBps() view returns (uint16)',
  'function maxWalletAmount() view returns (uint256)',
  'function maxTxAmount() view returns (uint256)',
] as const;

/**
 * Human-readable ABI for LaunchERC20Factory functions.
 */
export const LaunchERC20FactoryReadABI = [
  'function getCreationFee(uint256 chainId) view returns (uint256)',
  'function implementation() view returns (address)',
  'function predictAddress(bytes32 salt, bytes calldata initData) view returns (address)',
  'function tokenCount() view returns (uint256)',
  'event TokenCreated(address indexed token, address indexed owner, string name, string symbol)',
  'event InitialDistribution(address indexed token, address[] recipients, uint256[] amounts, string[] labels)',
] as const;
